/**
 * diantonio-datalayer.js (Caretakers, Phase 1 tracking — item 1a)
 *
 * Dynamic half of the storefront dataLayer. Spec: docs/tracking/measurement-plan.md
 * Loaded (defer) from snippets/diantonio-datalayer.liquid.
 *
 * - add_to_cart / remove_from_cart: snapshot /cart.js and diff it again on
 *   Stockholm's PUB_SUB_EVENTS.cartUpdate. Source-agnostic — catches the PDP
 *   form, featured-product sections, cart quantity steppers and the SCA
 *   Quickview app, without touching any vendor JS.
 * - begin_checkout: capture-phase click on the cart/drawer checkout buttons,
 *   payload from the last cart snapshot.
 */
(function () {
  'use strict';

  var config = window.diantonioDataLayerConfig || {};
  var currency = config.currency || 'NZD';
  var cartJsUrl = (config.cartUrl || '/cart') + '.js';

  window.dataLayer = window.dataLayer || [];

  var cartSnapshot = null; // { [variantId]: line } — null until first fetch resolves
  var refreshing = false;
  var refreshQueued = false;

  function lineToItem(line, quantity) {
    var item = {
      item_id: line.sku ? line.sku : String(line.variant_id),
      item_name: line.product_title,
      item_brand: line.vendor,
      item_category: line.product_type,
      price: line.final_price / 100,
      quantity: quantity,
      product_id: String(line.product_id),
      variant_id: String(line.variant_id)
    };
    if (line.variant_title && line.variant_title !== 'Default Title') {
      item.item_variant = line.variant_title;
    }
    return item;
  }

  function indexByVariant(cart) {
    var map = {};
    (cart.items || []).forEach(function (line) {
      // Same variant can appear as multiple lines (line-item properties); merge quantities.
      if (map[line.variant_id]) {
        map[line.variant_id] = Object.assign({}, line, {
          quantity: map[line.variant_id].quantity + line.quantity
        });
      } else {
        map[line.variant_id] = line;
      }
    });
    return map;
  }

  function pushEcommerce(eventName, items) {
    if (!items.length) return;
    var value = items.reduce(function (sum, item) {
      return sum + item.price * item.quantity;
    }, 0);
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecommerce: {
        currency: currency,
        value: Math.round(value * 100) / 100,
        items: items
      }
    });
  }

  function diffAndPush(previous, next) {
    var added = [];
    var removed = [];

    Object.keys(next).forEach(function (variantId) {
      var before = previous[variantId] ? previous[variantId].quantity : 0;
      var delta = next[variantId].quantity - before;
      if (delta > 0) added.push(lineToItem(next[variantId], delta));
    });
    Object.keys(previous).forEach(function (variantId) {
      var after = next[variantId] ? next[variantId].quantity : 0;
      var delta = previous[variantId].quantity - after;
      if (delta > 0) removed.push(lineToItem(previous[variantId], delta));
    });

    pushEcommerce('add_to_cart', added);
    pushEcommerce('remove_from_cart', removed);
  }

  function refreshCart(emitDiff) {
    if (refreshing) {
      refreshQueued = true;
      return;
    }
    refreshing = true;
    fetch(cartJsUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var next = indexByVariant(cart);
        if (emitDiff && cartSnapshot !== null) diffAndPush(cartSnapshot, next);
        cartSnapshot = next;
      })
      .catch(function () { /* network hiccup — keep last snapshot, next event re-syncs */ })
      .finally(function () {
        refreshing = false;
        if (refreshQueued) {
          refreshQueued = false;
          refreshCart(true);
        }
      });
  }

  function onCheckoutIntent() {
    if (cartSnapshot === null) return;
    var items = Object.keys(cartSnapshot).map(function (variantId) {
      return lineToItem(cartSnapshot[variantId], cartSnapshot[variantId].quantity);
    });
    pushEcommerce('begin_checkout', items);
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest('button[name="checkout"], a[href*="/checkout"]')
      : null;
    if (target) onCheckoutIntent();
  }, true);

  function init() {
    refreshCart(false);
    // Stockholm (Dawn-style) pubsub — subscribe/publish are plain globals from
    // assets/pubsub.js, loaded defer'd before this file.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshCart(true); });
    }
    // Fallback for cart writes that bypass the theme's pubsub (third-party
    // apps calling /cart/add.js directly, e.g. quick-view): watch fetch.
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      var result = originalFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        result.then(function () { refreshCart(true); }, function () {});
      }
      return result;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
